import { Breadcrumb, Button, Col, Form, Input, Radio, Row, Table } from "antd";
import { ExportOutlined, HomeOutlined, SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { Excel } from "antd-table-saveas-excel";
import { _adr } from "../../../../address";
import { useEffect, useState } from "react";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { convertToJalaliWithoutTime } from "../../../../tools/tools";
import { NotFound } from "../../../../sources/svg/svg";
import Loading from "../../../auxiliary/loader/loading";
import styles from "./dealerKitInventory.module.scss";
const DealerKitInventory = () => {
	const [frmSearch] = Form.useForm();

	const { queryPoolType } = useAPIPublic();
	const { queryDealerPoolMapping, queryAssignedKit } = useDealer();

	const [pool, setPool] = useState([]);
	const [selectedPoolType, setSelectedPoolType] = useState(null);

	const [isLoading, setIsLoading] = useState(false);

	// state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	useEffect(() => {
		// همون منبع pool که تو صفحه‌ی «درخواست» استفاده شده
		const loadPool = async () => {
			try {
				const [poolTypes, dealerPools] = await Promise.all([queryPoolType(), queryDealerPoolMapping()]);
				if (Array.isArray(poolTypes) && Array.isArray(dealerPools)) {
					const filteredPools = poolTypes.filter((item) => dealerPools.some((map) => Number(map.poolType) === Number(item.value)));
					setPool(filteredPools);

					const defaultPool = filteredPools.find((item) => Number(item.value) === 1) || filteredPools[0];
					if (defaultPool) {
						setSelectedPoolType(Number(defaultPool.value));
					}
				}
			} catch (error) {
				console.error("Failed to load pool types:", error);
			}
		};
		loadPool();
	}, []);

	const cTable = [
		{
			title: "کیت",
			dataIndex: "iccid",
			key: "iccid",
			width: 150,
		},
		{
			title: "نوع مخزن",
			dataIndex: "iccidPoolName",
			key: "iccidPoolName",
			width: 180,
		},
		{
			title: "تاریخ تخصیص",
			dataIndex: "transferDate",
			key: "transferDate",
			width: 150,
		},
	];

	const [dataSource, setDataSource] = useState([]);

	const handleSearch = async () => {
		if (!selectedPoolType) return;
		setIsLoading(true);
		try {
			const values = frmSearch.getFieldsValue();
			const payload = {
				searchConfigModel: {
					sort: "",
					filter: values?.iccid || "",
					entriesPerPage: 10,
					page: currentPage === 0 ? 0 : currentPage - 1,
					totalRowCount: 0,
				},
				poolType: [selectedPoolType],
			};

			const response = await queryAssignedKit(payload);
			if (response) {
				setDataSource(
					(response?.Result || []).map((item, key) => ({
						key,
						iccid: item.iccid,
						iccidPoolName: item.iccidPoolName,
						transferDate: convertToJalaliWithoutTime(item.dtE_TransferDate),
					})),
				);
				setTotalRecord(response?.searchconfigmodel?.totalrowcount || 0);
			}
		} catch (error) {
			console.error("Failed to load assigned kits:", error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (selectedPoolType) {
			handleSearch();
		}
	}, [selectedPoolType, currentPage]);

	const handleExport = () => {
		const excel = new Excel();
		excel.addSheet("موجودی کیت نماینده").addColumns(cTable).addDataSource(dataSource, { str2Percent: true }).saveAs("dealer-kit-inventory.xlsx");
	};

	return (
		<div className="container-main container-cw">
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[
							{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest, title: "مدیریت کیت سیم‌کارت" },
							{ title: "موجودی کیت نماینده" },
						]}
					/>
					<div className="title-page">
						<h3>موجودی کیت نماینده</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className={`g-body-format-page ${styles.container}`}>
							<Row justify="start">
								<Col>
									<Radio.Group
										className="input-normal"
										value={selectedPoolType}
										onChange={(e) => {
											setCurrentPage(0);
											setSelectedPoolType(e.target.value);
										}}>
										{pool.map((item) => (
											<Radio key={item.value} value={Number(item.value)}>
												مخزن {item.name}
											</Radio>
										))}
									</Radio.Group>
								</Col>
							</Row>

							<div className="holder-table">
								<div className="holder-top-table">
									<div className="holder-search">
										<Form form={frmSearch} onFinish={handleSearch} layout="inline">
											<Form.Item name="iccid" className="input-normal">
												<Input placeholder="شماره کیت" allowClear />
											</Form.Item>
											<Form.Item>
												<Button htmlType="submit" className="btn-normal btn-aptel" icon={<SearchOutlined />} />
											</Form.Item>
										</Form>
									</div>
									<div className="holder-button">
										<Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
											خروجی اکسل
										</Button>
									</div>
								</div>
								<Table
									className="tbl-normal"
									columns={cTable}
									locale={{
										emptyText: <NotFound text={"رکوردی یافت نشد."} />,
									}}
									pagination={{
										className: "page-pagination",
										onChange: (page) => {
											setCurrentPage(page);
										},
										pageSize: 10,
										align: "start",
										current: currentPage === 0 ? 1 : currentPage,
										total: totalRecord,
										showSizeChanger: false,
									}}
									scroll={{ y: "100%" }}
									dataSource={dataSource}
								/>
							</div>
						</div>
					</div>
				</Content>
				<Loading isOpen={isLoading} />
			</div>
		</div>
	);
};

export default DealerKitInventory;
